import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [carts, setCarts] = useState(() => {
    try { return JSON.parse(localStorage.getItem("carts") || "{}"); } catch { return {}; }
  });

  useEffect(() => { localStorage.setItem("carts", JSON.stringify(carts)); }, [carts]);

  const getCart = (storeId) => carts[storeId] || [];

  const addToCart = (storeId, product) => {
    setCarts(prev => {
      const cart = prev[storeId] || [];
      const found = cart.find(i => i.product_id === product.product_id);
      const newCart = found
        ? cart.map(i => i.product_id === product.product_id ? { ...i, quantity: i.quantity + 1 } : i)
        : [...cart, { product_id: product.product_id, name: product.name, price: product.price, image_url: product.image_url, quantity: 1 }];
      return { ...prev, [storeId]: newCart };
    });
  };

  const setQty = (storeId, productId, qty) => {
    setCarts(prev => {
      const cart = (prev[storeId] || []).map(i => i.product_id === productId ? { ...i, quantity: Math.max(1, qty) } : i);
      return { ...prev, [storeId]: cart };
    });
  };

  const removeItem = (storeId, productId) => {
    setCarts(prev => ({ ...prev, [storeId]: (prev[storeId] || []).filter(i => i.product_id !== productId) }));
  };

  const clearCart = (storeId) => setCarts(prev => ({ ...prev, [storeId]: [] }));

  return (
    <CartCtx.Provider value={{ getCart, addToCart, setQty, removeItem, clearCart }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
